type Pixel = number;
type Rem = string;
type Em = string;

const toPx = (maybePx: string | number): Pixel => {
  if (typeof maybePx === 'number') return maybePx;
  if (!maybePx.endsWith('px')) throw new Error(`not px unit: "${maybePx}"`);
  return parseFloat(maybePx);
};

export const makePxToRem =
  (rootFontSize: string) =>
  (px: string | number): Rem =>
    `${toPx(px) / toPx(rootFontSize)}rem`;
export const makePxToEm =
  (rootFontSize: string) =>
  (px: string | number): Em =>
    `${toPx(px) / toPx(rootFontSize)}em`;

export const makeRemToPx =
  (rootFontSize: string) =>
  (rem: Rem): Pixel => {
    if (!rem.endsWith('rem')) throw new Error(`not rem unit: "${rem}"`);
    const remAsNumber = parseFloat(rem);
    const baseFontSize = toPx(rootFontSize);
    return remAsNumber * baseFontSize;
  };
export const makeEmToPx =
  (rootFontSize: string) =>
  (em: Em): Pixel => {
    if (em.endsWith('rem') || !em.endsWith('em')) throw new Error(`not em unit: "${em}"`);
    const emAsNumber = parseFloat(em);
    const baseFontSize = toPx(rootFontSize);
    return emAsNumber * baseFontSize;
  };

const rootElement = globalThis.document?.querySelector(':root');
const computedRootFontSize = globalThis.getComputedStyle?.(rootElement as HTMLElement).fontSize;
// Browsers always resolve the root font-size to a px value; jsdom (since v27) returns the CSS
// keyword `medium` for an unstyled root, which toPx() can't parse — fall back to 16px unless we
// actually got px back.
const rootFontSizeInPx = computedRootFontSize?.endsWith('px') ? computedRootFontSize : '16px';
export const remToPx = makeRemToPx(rootFontSizeInPx);
export const emToPx = makeEmToPx(rootFontSizeInPx);
export const pxToEm = makePxToEm(rootFontSizeInPx);
export const pxToRem = makePxToRem(rootFontSizeInPx);
